import { useState } from 'react'
import AdminNavigationLayout from 'shared/Layouts/TopNavigationLayout/AdminNavifationLayout'
import TopNavigationLayoutPageContent from 'shared/Layouts/TopNavigationLayout/TopNavigationLayoutPageContent'
import Button from 'shared/Buttons/Button/Button'
import useHttpLoader from 'shared/hooks/useHttpLoader'
import { useSetRecoilState } from 'recoil'
import { useNavigate } from 'react-router-dom'
import projectTechnologiesTableAtom from '../../componenets/ProjectTechnologiesTable/projectTechnologiesTable.atom'
import projectTechnologiesApi from '../../projectTechnologies.api'
import ProjectTechnologySheet from '../../componenets/ProjectTechnologySheet'

const CreateProjectTechnologyPage = () => {
  const navigate = useNavigate()
  const { wait, loading } = useHttpLoader()
  const [draft, setDraft] = useState({ title: '', description: '' })
  const setState = useSetRecoilState(projectTechnologiesTableAtom)

  const handleChange = (val: any, name: string) => {
    setDraft((prev) => ({ ...prev, [name]: val }))
  }

  const handleSave = () => {
    wait(projectTechnologiesApi.create(draft), (resp) => {
      if (resp.status === 'success') {
        setState((prev) => ({ ...prev, items: [resp.body, ...prev.items] }))
        navigate('/admin/project-technologies')
      }
    })
  }

  return (
    <AdminNavigationLayout>
      <TopNavigationLayoutPageContent type='default'>
        <div className='flex-space-between'>
          <div className='inline-flex-gap' style={{ gap: '2.5em' }}>
            <h2 className='page--header'>Создание ключевой технологии</h2>
          </div>
        </div>
        <ProjectTechnologySheet technology={draft} onChange={handleChange}>
          <Button theme='primary' loading={loading} onClick={handleSave} style={{ width: 'fit-content' }}>
            Создать
          </Button>
        </ProjectTechnologySheet>
      </TopNavigationLayoutPageContent>
    </AdminNavigationLayout>
  )
}

export default CreateProjectTechnologyPage
